import modals from "toolConstants/warehouseDesigner/modals";
import menus from "toolConstants/warehouseDesigner/menus";
import actions, {conditions as actionConditions, actionDispatchers} from "toolConstants/warehouseDesigner/actions";
import initialState from "toolConstants/warehouseDesigner/initalState";
import {containerCondition, containerElements, areaCondition, areaElements, otherElements} from "toolConstants/warehouseDesigner/views";
import {setArea, resetArea, calculateEquipmentTable} from "toolConstants/warehouseDesigner/logic";
import reportDocument from "toolConstants/warehouseDesigner/reportDocument";
import constants from "toolConstants/warehouseDesigner/constants";
import validate from "toolConstants/warehouseDesigner/validation"

const WD = {
  initialState,
  modals,
  menus,
  reportDocument,

  actions,
  actionConditions,
  actionDispatchers,
  containerCondition,
  containerElements,
  areaCondition,
  areaElements, 
  otherElements,

  constants,
  setArea,
  resetArea,
  calculateEquipmentTable,
  validate,
};

export default WD;